export function calculateInvoiceAmounts(
  baseAmount: number,
  gstEnabled: boolean,
  gstRate: number,
  discountAmount = 0,
  discountPercent = 0
) {
  const base = Math.round((Number(baseAmount) || 0) * 100) / 100;
  const rate = Number(gstRate) || 0;
  let discount = Math.round((Number(discountAmount) || 0) * 100) / 100;
  const pct = Number(discountPercent) || 0;
  if (pct > 0) discount = Math.round((base * pct) / 100 * 100) / 100;
  const taxableAmount = Math.round(Math.max(0, base - discount) * 100) / 100;
  const gstAmount = gstEnabled ? Math.round((taxableAmount * rate) / 100 * 100) / 100 : 0;
  const totalAmount = Math.round((taxableAmount + gstAmount) * 100) / 100;
  return { baseAmount: base, discountAmount: discount, discountPercent: pct, taxableAmount, gstAmount, totalAmount };
}
